import { render, staticRenderFns } from "./associates.vue?vue&type=template&id=2828119a&"
import script from "./associates.vue?vue&type=script&lang=js&"
export * from "./associates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports